import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-wo_033",
  "use": "icon-wo_033-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-wo_033\"><defs><style>#icon-wo_033 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-wo_033_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-wo_033_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><rect class=\"cls-2\" x=\"11\" y=\"7\" width=\"6\" height=\"9\" /><path class=\"cls-2\" d=\"M3,3V20H21V3ZM5,5H7V8H5Zm0,5H7v3H5Zm0,8V15H7v3Zm14,0H9V5H19Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol